"use client";

import styles from "./AuthorizeForgotPasswordLink.module.scss";
import { useLocale } from "@/i18n";
import { withLocale } from "@/helpers";
import { Link } from "react-router-dom";

/**
 * AuthorizeForgotPasswordLink Component
 *
 * Link to password reset page for users who forgot their password.
 */
export const AuthorizeForgotPasswordLink = () => {
  const locale = useLocale();

  return (
    <Link
      to={withLocale(locale, "/forgot-password")}
      className={styles["comp"]}
    >
      Forgot password?
    </Link>
  );
};
